module.exports = __webpack_public_path__ + "static/media/model.1bcb23f8.glb";